import classnames from 'classnames';
import DocumentMeta from 'react-document-meta';
import React, {Component} from 'react';
import {inject, observer} from 'mobx-react'; // eslint-disable-line no-unused-vars

import * as contentHelpers from '../utilities/contentHelpers';
import AlertWrapper from '../components/AlertWrapper';
import ImageField from './persona/ImageField';
import ListField from './persona/ListField';
import PersonaHeader from './persona/PersonaHeader';
import Sidebar from './persona/Sidebar';
import SuccessCriteria from './persona/SuccessCriteria';
import Summary from './persona/Summary';
import TechnologyComfort from './persona/TechnologyComfort';
import TemplateSelector from './persona/TemplateSelector';

import './Persona.scss';

@inject(
  'alertStore',
  'personaStore',
  'sidebarStore',
  'templateStore',
  'routerStore',
)
@observer
export default class Persona extends Component {
  componentDidMount() {
    const {alertStore, personaStore, sidebarStore, templateStore} = this.props;

    if (personaStore.isHome) {
      templateStore.showTemplateSelector();
    }

    if (!personaStore.isEditable) {
      sidebarStore.toggleIndicators(false);
      alertStore.addViewOnlyAlert();
    }
  }

  render() {
    const {
      alertStore,
      personaStore,
      templateStore,
      sidebarStore,
    } = this.props;
    const template = templateStore.selectedTemplate;
    const persona = personaStore.body || {}; // Setting to an empty item if this comes back undefined
    const name = contentHelpers.getName(persona.name, template.name);
    const title = name === 'Blank' ? 'Create a new persona' : name + '\'s persona';
    const description = contentHelpers.getDescription(persona.summary, template.summary);
    const meta = {
      title: title + ' | PersonaGenerator',
      description: description,
      "og:title": 'Custom User Persona for ' + name,
      "og:description": 'Created using PersonaGenerator.com',
      "twitter:title": 'Custom User Persona for ' + name,
      "twitter:description": 'Created using PersonaGenerator.com',
      auto: {
        ograph: true
      }
    };
    const personaClasses = classnames([
      'persona',
      {
        'hide-indicators': !sidebarStore.showIndicators
      }
    ]);
    return (
      <div className="row">
        <DocumentMeta {...meta} />
        <div className="col-xs-12 col-md wrapper">
          {
            alertStore.alerts.length > 0 &&
            <AlertWrapper alerts={alertStore.alerts} dismissAlert={alertStore.dismissAlert}/>
          }
          {templateStore.templateSelectorVisible && (
            <TemplateSelector />
          )}
          <div className={personaClasses}>
            <div className="persona-wrapper-inner">
              <PersonaHeader
              />
              <Summary
                placeholder={`A quick summary of behaviors and practices like how he/she spends
                  their day.`}
              />
              <div className="container-fluid">
                <div className="row">
                  <TechnologyComfort />
                  <SuccessCriteria
                    placeholder="What's needed in order to make him or her feel successful."
                  />
                </div>
                <div className="row">
                  <ListField
                    formKey="needs"
                    placeholder={
                      [
                        'These should be required',
                        'This might be Spanish localized content',
                        'Support from higher ups'
                      ]
                    }
                  />
                  <ListField
                    formKey="wants"
                    placeholder={
                      [
                        'Wants are something that is not required but delights',
                        'This might be the holy grail feature',
                        'It delights him or her with its simplicity or completeness'
                      ]
                    }
                  />
                </div>
                <div className="row">
                  <ListField
                    formKey="values"
                    placeholder={
                      [
                        'Qualities that he or she values',
                        'High level planning is an example'
                      ]
                    }
                  />
                  <ListField
                    formKey="fears"
                    placeholder={
                      [
                        'Fears are the things that keep him or her up at night',
                        'This might be something like failure',
                        'But might also have to do with real fear'
                      ]
                    }
                  />
                </div>
              </div>
            </div>
            <div className="persona-wrapper-outer">
              <ImageField
                formKey="logo_image"
                images={['/logo-blank.png', '/logo-ml.png', '/logo-1.png']}
                {...this.props}
              />
            </div>
          </div>
        </div>
        {
          !personaStore.inIframe &&
          <Sidebar />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/Persona.jsx